query SentenceGroupCategoriesQuery {
  sentenceGroupCategories {
    id
    description
    order
  }
}
